import { Component } from '@angular/core';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTable } from "primeng/components/datatable/datatable";
import { JobRequest } from '../../../../models/inModels/jobRequest';
import { JobRequestService } from '../../../../services/business/job-request.service';
import { NotificationContentType } from '../../../../models/inModels/MessageModel';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';

@Component({
	selector: 'app-job-requests',
	templateUrl: './job-requests.component.html',
	styleUrls: ['./job-requests.component.css']
})
export class JobRequestsComponent {
	jobRequest: JobRequest[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	constructor(
		private route: ActivatedRoute,
		private requestService: JobRequestService,
		private router: Router,
		private confirmationService: ConfirmationService,
		private auth: AuthenticationService) {

		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.requestService.search(event).then(
			dataPager => {
				this.jobRequest = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.jobRequest = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(jobRequest: JobRequest) {
		console.log(jobRequest);
		this.router.navigate(['requests/edit', jobRequest.Id]);
	}

	delete(jobRequest: JobRequest) {
		console.log(jobRequest);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${jobRequest.CompanyName}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.requestService.delete(jobRequest.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
	sendAllDialogOpen(jobRequest: JobRequest) {
		this.contentId = jobRequest.Id;
		this.contentType = NotificationContentType.Sale;
		this.sendAllDialog = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/sales/job-requests/job-requests/job-requests.component.ts